import type { CameraMemo } from "~/entities/camera-memo/types";
import axiosInstance from "~/shared/api/axios-instance";

interface CameraMemoResponse {
  id: number;
  type: 0 | 1;
  floor_plan_id: number | null;
  floor_plan_coordinates: { x: number; y: number } | null;
  content: string;
  pseudo_camera_orientation_id: number;
  created_at?: number;
  updated_at: number;
}

export async function fetchCameraMemos(
  branchUid: string,
  versionId?: number,
): Promise<CameraMemo[]> {
  const { data } = await axiosInstance.get<CameraMemoResponse[]>(
    `branches/${branchUid}/comments/`,
    { params: { version: versionId } },
  );

  return data.map((memo) => ({
    id: memo.id,
    cameraId: memo.pseudo_camera_orientation_id,
    type: memo.type === 0 ? "default" : "adjustmentOrAddition",
    content: memo.content,
    floorPlanId: memo.floor_plan_id,
    positionForFloorPlan: memo.floor_plan_coordinates,
    createdAt: memo.created_at ?? null,
    updatedAt: memo.updated_at,
  }));
}
